import az from "@/i18n/az";
import ru from "@/i18n/ru";
import en from "@/i18n/en";
export default {
    en: en,
    ru: ru,
    az: az
}
